import { render, staticRenderFns } from "./jigou.vue?vue&type=template&id=7b61f238&scoped=true&"
import script from "./jigou.vue?vue&type=script&lang=js&"
export * from "./jigou.vue?vue&type=script&lang=js&"
import style0 from "./jigou.vue?vue&type=style&index=0&id=7b61f238&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b61f238",
  null
  
)

export default component.exports